
export const FACET_PLAN_VIEW_SIDEBAR_SUMMARY = 'FacetPlanViewSidebarSummary';
export const FACET_PLAN_OUTCOME_PRIORITIZATION_ITEM = 'FacetPlanViewSidebarOutcomes';
export const FACET_PLAN_SAC = 'facetPlanSmartAllocationCustomization';
export const FACET_PLAN_SAC_OUTCOMES = 'facetPlanSmartAllocationCustomizationOutcomes';
export const FACET_PLAN_VIEW_SIDEBAR_BALANCE_SHEET = 'FacetPlanBalanceTransferRollover';
export const FACET_PLAN_VIEW_SIDEBAR_ASSUMPTIONS = 'FacetPlanViewSidebarAssumptions';
export const FACET_PLAN_VIEW_SIDEBAR_SCENARIOS = 'FacetPlanScenarioPage';
export const FACET_PLAN_VIEW_SIDEBAR_ARCHIVES = 'FacetPlanArchivePage';
export const FACET_PLAN_VIEW_SIDEBAR_PROPOSALS = 'FacetPlanProposalPage';
export const FACET_PLAN_VIEW_SIDEBAR_EXPENSES = 'FacetPlanViewSidebarExpenses';
export const FACET_PLAN_VIEW_SIDEBAR_LOGS = 'FacetPlanViewSidebarLog';
export const FACET_PLAN_VIEW_SIDEBAR_RESOURCES = 'FacetPlanViewSidebarResources';
export const FACET_PLAN_VIEW_SIDEBAR_JOBS = 'FacetPlanViewSidebarJobs';
export const FACET_PLAN_VIEW_SIDEBAR_DESIRED_OUTCOMES = 'FacetPlanViewSidebarDesiredOutcomes';
export const FACET_PLAN_VIEW_SIDEBAR_AUTOMATION_SUGGESTIONS = 'FacetPlanRunAutomations';
export const FACET_PLAN_CURRENT_MONTH_CONFIGURATIONS = 'FacetPlanCurrentMonthConfigurations';
export const TEMPLATE_TYPE_NOTE = 'note';
export const TEMPLATE_TYPE_AUTOMATED = 'automated';
export const TEMPLATE_TYPE_MESSAGE_MEETING_COMBO = 'messageMeetingCombo';

export const CAME_TO_INVESTMENTS_PAGE_FROM = 'investmentsPageOrigin';
export const FACET_PLAN_SIDEBAR_QUERY_PARAM = 'sidebarTab';
export const DETAILS_TAB_QUERY_PARAM = 'detailsTab';
export const ROW_FILTER_QUERY_PARAM = 'rowFilter';

export const META_GOTO_SIDEBAR_BALANCE_SHEET = 'money-movement';
